// src/components/common/LimiteError.jsx
// Atrapa errores al mostrar una pantalla. Caso principal: tras un despliegue nuevo, una pestaña abierta con la
// versión anterior pide un archivo (chunk) que ya no existe; el hosting responde con index.html y la carga falla.
// En ese caso se recarga la página UNA vez (así se baja la versión nueva); si vuelve a fallar se muestra un aviso.
import React from 'react';

const CLAVE = 'gr-recarga-chunk';
const VENTANA_MS = 60 * 1000;

function esErrorDeCarga(error) {
  const texto = `${error?.name || ''} ${error?.message || ''}`;
  return /ChunkLoadError|Loading (CSS )?chunk|dynamically imported module|Unexpected token '<'/i.test(texto);
}

export default class LimiteError extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, recargando: false };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    console.error('[LimiteError]', error);
    if (!esErrorDeCarga(error)) return;
    try {
      const ultima = Number(sessionStorage.getItem(CLAVE) || 0);
      if (Date.now() - ultima > VENTANA_MS) {
        sessionStorage.setItem(CLAVE, String(Date.now()));
        this.setState({ recargando: true });
        window.location.reload();
      }
    } catch (e) { /* sin sessionStorage: se muestra el aviso */ }
  }

  render() {
    const { error, recargando } = this.state;
    if (!error) return this.props.children;
    if (recargando) return null;
    return (
      <div role="alert" className="flex flex-col items-center justify-center gap-3 text-center px-6 py-20"
           style={this.props.enLinea ? undefined : { minHeight: '100vh', background: '#0A0A0A' }}>
        <p className="text-white font-semibold">No se pudo cargar esta pantalla.</p>
        <p className="text-sm" style={{ color: 'rgba(255,255,255,0.6)' }}>
          Revisa tu conexión a internet y vuelve a intentarlo.
        </p>
        <button type="button" className="btn-red px-5 py-2 text-sm" onClick={() => window.location.reload()}>
          Recargar
        </button>
      </div>
    );
  }
}
